enum NavSection {
    SCHOOLADMINISTRATION = 'SCHOOLADMINISTRATION',
    SCHEDULESYNC = 'SCHEDULESYNC',
    ONEROSTER = 'ONEROSTER',
    CONFIGURATION = 'CONFIGURATION',
    DEVICES = 'DEVICES',
    PASSWORDADMINISTRATION = 'PASSWORDADMINISTRATION',
    CLASSROOMADMIN = 'CLASSROOMADMINISTRATION'
}

export default NavSection;